"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: 1,
    p: 2,
    borderRadius: '3px'
  },
  title: {
    fontSize: 14,
    lineHeight: '18px',
    color: 'text.main',
    mb: 1
  },
  text: {
    fontSize: 12,
    lineHeight: '16px',
    color: 'text.main',
    mb: 1
  },
  emailPreviewText: {
    fontSize: 12,
    lineHeight: '16px',
    color: 'text.main',
    m: 0
  },
  reconnectLink: {
    display: 'inline-block'
  },
  info: {
    backgroundColor: 'additional.chambray05'
  },
  warning: {
    backgroundColor: 'red.brickRed10'
  },
  success: {
    backgroundColor: 'green.light'
  }
};
exports.styles = styles;